<template>
  <ul v-if="facts.length" class="an-facts">
    <li v-for="(fact, i) in facts" :key="i" class="an-facts__item" :class="'an-facts__item--' + (fact.tone || 'neutral')">
      <i class="fa an-facts__icon" :class="icon(fact.tone)"></i>
      <span>{{ fact.text }}</span>
    </li>
  </ul>
</template>

<script>
const ICONS = {bad: 'fa-exclamation-circle', warn: 'fa-exclamation-triangle', good: 'fa-check-circle', neutral: 'fa-info-circle'}

/** «Главное» вверху вкладки: одна-две строки, чтобы не разглядывать таблицу. */
export default {
  name: "RumFacts",
  props: {
    facts: {type: Array, required: true},
  },
  methods: {
    icon(tone) {
      return ICONS[tone] || ICONS.neutral
    },
  },
}
</script>
